<template>
  <div class="space-item-container" :class="{'noCalendar' : (isScheduleGroup == 0 && !props.isCampaign), 'isCampaign' : (props.isCampaign && isScheduleGroup), 'isCampaignAndNoCalendar' : (props.isCampaign && !isScheduleGroup)}" >
    <router-link class="space-image-group" :to="handelGotoDetailSpace(props.spaceInfo?.display_id)">
      <img
        class="space_image"
        :src="ImageResizing(props.spaceInfo?.rental_space_image[0].url_image, 20)"
        :alt="props.spaceInfo?.generalBasicSpaceNameJa"
      />
      <div
        class="bestrate-ribbon"
        v-if="props.spaceInfo?.generalBasicSpaceManageType"
      >
        <img
          v-if="
            props.spaceInfo?.generalBasicSpaceManageType === 'our-company' ||
            props.spaceInfo?.generalBasicSpaceManageType ===
              'own-company-skima' ||
            props.spaceInfo?.generalBasicSpaceManageType ===
              'management-our-brand'
          "
          :src="bestRateIcon"
          alt="ベストレート"
          style="width: 50px; height: 55px"
        />
      </div>
      <div class="bestrate-ribbon" v-else>
        <img
          v-if="
            props.spaceInfo?.manage_type === 'our-company' ||
            props.spaceInfo?.manage_type === 'own-company-skima' ||
            props.spaceInfo?.manage_type === 'management-our-brand'
          "
          :src="bestRateIcon"
          alt="ベストレート"
          style="width: 50px; height: 55px"
        />
      </div>
      <div v-if="isSortByGroup && !isArea">
        <div class="label-number-red" v-if="(props.spaceInfo?.rental_space_sort_order_position && props.spaceInfo?.rental_space_sort_order_position <= 6 ) && props.spaceInfo?.group_area_name">
          <span class="name-area">{{ props.spaceInfo?.group_area_name }}の</span>
          <span class="number"
            >おすすめ
            <p>{{ props.spaceInfo?.rental_space_sort_order_position }}位</p></span
          >
        </div>
      </div>
      <div v-else-if="!isArea">
        <div class="label-number-red" v-if="(props.spaceInfo?.rental_space_sort_order_position && props.spaceInfo?.rental_space_sort_order_position <= 6) && (props.spaceInfo?.areas && props.spaceInfo?.areas?.name)">
          <span class="name-area" v-if="props.isCampaign">{{ props.spaceInfo?.areas }}の</span>
          <span class="name-area" v-else>{{ props.spaceInfo?.areas?.name }}の</span>
          <span class="number"
            >おすすめ
            <p>{{ props.spaceInfo?.rental_space_sort_order_position }}位</p></span
          >
        </div>
      </div>

      <div class="new-ribbon" v-if="isNew(props.spaceInfo)">
        <img :src="newIcon" alt="new" />
      </div>

      <div class="discount-ribbon" v-if="isDiscount(props.spaceInfo)">
        <img :src="discountIcon" alt="discount" />
      </div>
    </router-link>

    <div class="space-info">
      <router-link
        class="space-name"
        :to="handelGotoDetailSpace(props.spaceInfo?.display_id)"
        style="color: #000000; text-decoration: none"
      >
        <h3 class="name-label">{{ truncatedText }}</h3>
        <div class="campaign-time" v-if="props.isCampaign">
          特別価格期間：{{ props.spaceInfo?.start_date }} 〜 {{ props.spaceInfo?.end_date }}
        </div>
      </router-link>
      <div class="favorite-container">
        <img
          v-if="isFavorite"
          :src="HeartRed"
          class="favorite-icon"
          alt="favorite icon"
          @click="handleFavoriteSpaceId(props.spaceInfo?.id)"
        />
        <img
          v-else
          :src="HeartGray"
          class="favorite-icon"
          alt="favorite icon"
          @click="handleFavoriteSpaceId(props.spaceInfo?.id)"
        />
      </div>
      <div
        class="price-group"
        style="color: #000000; text-decoration: none"
      >
        <div class="price for-sp" v-if="props.isCampaign" style="font-family: 'Inter', sans-serif;">
          <span style="text-decoration: line-through" class="campaign-price"
            >{{
              Number(
                Math.floor(1.1 * props.spaceInfo?.per_person_price)
              ).toLocaleString() + '円'
            }}〜</span
          >
          <svg
            width="20"
            height="19"
            viewBox="0 0 20 19"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10.9888 18.6832L9.08683 16.7997L14.7836 11.103H0.943359V8.35156H14.7836L9.08683 2.66406L10.9888 0.771306L19.9448 9.72727L10.9888 18.6832Z"
              fill="#666666"
            />
          </svg>
          <span class="campaign-price" style="color: #ff3f3f"
            >{{
              Math.floor(
                Number(1.1 * props.spaceInfo?.per_person_price) -
                  (Number(props.spaceInfo?.discount_rate) *
                    Number(1.1 * props.spaceInfo?.per_person_price)) /
                    100
              ).toLocaleString() + '円'
            }}〜</span
          >/1H
        </div>
        <div class="price for-sp" v-else>
          <PanoramaButton 
            :spaceInfo="props.spaceInfo" 
            outerClass="main-panorama-degree-tour-sp" 
            innerClass="panorama-degree-tour-sp"
          />
          <span>
          {{
            Math.floor(
              props.spaceInfo?.per_person_price * 1.1
            ).toLocaleString()+ '円'
          }}〜/1H
          </span>
        </div>
        <div class="basic-info">
          <div class="address">
            {{ props.spaceInfo?.location }}
          </div>
          <div class="info-group">
            <div class="station" v-if="props.spaceInfo?.walking_duration !==null && props.spaceInfo?.walking_duration !== undefined">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="8"
                height="13"
                viewBox="0 0 8 13"
                fill="none"
              >
                <path
                  d="M3.7575 1.87088C3.7575 1.25088 4.2575 0.740875 4.8875 0.740875C5.5175 0.740875 6.0175 1.24088 6.0175 1.87088C6.0175 2.50088 5.5175 3.00088 4.8875 3.00088C4.2575 3.00088 3.7575 2.50088 3.7575 1.87088ZM2.9675 5.42088C2.9675 5.42088 2.9275 5.44088 2.8975 5.45088L2.7075 5.53088C2.3275 5.70088 2.0275 6.03088 1.8975 6.43088L1.8375 6.61088C1.7075 7.00087 1.2775 7.21088 0.8875 7.08088C0.4975 6.95088 0.2875 6.52087 0.4175 6.13088L0.4775 5.95088C0.7475 5.15088 1.3375 4.50088 2.1075 4.16088L2.2975 4.08088C2.7875 3.86088 3.3075 3.75088 3.8475 3.75088C4.8975 3.75088 5.8375 4.38088 6.2375 5.34088L6.5975 6.20088L7.0975 6.45088C7.4675 6.64088 7.6175 7.09088 7.4375 7.46088C7.2475 7.83087 6.7975 7.98088 6.4275 7.80088L5.7975 7.49088C5.5575 7.37088 5.3675 7.17088 5.2675 6.92088L5.0375 6.38088L4.5875 7.92088L5.7475 9.19088C5.8775 9.33088 5.9675 9.49088 6.0075 9.68087L6.5475 11.8409C6.6475 12.2409 6.4075 12.6509 5.9975 12.7509C5.5975 12.8509 5.1875 12.6109 5.0875 12.2009L4.5675 10.1409L2.9075 8.33088C2.5575 7.95088 2.4275 7.43088 2.5675 6.93088L2.9675 5.44088V5.42088ZM1.6175 10.0809L2.2075 8.62088C2.2575 8.69088 2.3175 8.76087 2.3675 8.82088L3.3175 9.86088L2.9775 10.7109C2.9175 10.8509 2.8375 10.9809 2.7275 11.0909L1.2775 12.5409C0.9875 12.8309 0.5075 12.8309 0.2175 12.5409C-0.0725 12.2509 -0.0725 11.7709 0.2175 11.4809L1.6075 10.0909L1.6175 10.0809Z"
                  fill="#333333"
                />
              </svg>
              <span
                >{{ props.spaceInfo?.station_name }}駅徒歩{{ props.spaceInfo?.walking_duration }}分</span
              >
            </div>
            <div class="time">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="11"
                height="11"
                viewBox="0 0 11 11"
                fill="none"
              >
                <path
                  d="M5.50853 0.757202C2.74853 0.757202 0.513535 2.9972 0.513535 5.7572C0.513535 8.5172 2.74853 10.7572 5.50853 10.7572C8.27353 10.7572 10.5135 8.5172 10.5135 5.7572C10.5135 2.9972 8.27353 0.757202 5.50853 0.757202ZM7.15853 8.1122L5.01353 5.9622V3.2572H6.01353V5.5522L7.86853 7.4072L7.15853 8.1122Z"
                  fill="#333333"
                />
              </svg>
              <span>{{ props.spaceInfo?.minimum_usage_time }} 分〜</span>
            </div>
            <div class="people">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="13"
                viewBox="0 0 14 13"
                fill="none"
              >
                <path
                  d="M10.9302 11.4447V10.403C10.9302 9.8505 10.7107 9.3206 10.32 8.9299C9.92931 8.5392 9.3994 8.3197 8.84687 8.3197H4.6802C4.12767 8.3197 3.59777 8.5392 3.20706 8.9299C2.81636 9.3206 2.59687 9.8505 2.59687 10.403V11.4447"
                  stroke="#333333"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M6.76353 6.23637C7.91413 6.23637 8.84687 5.30363 8.84687 4.15304C8.84687 3.00244 7.91413 2.0697 6.76353 2.0697C5.61294 2.0697 4.6802 3.00244 4.6802 4.15304C4.6802 5.30363 5.61294 6.23637 6.76353 6.23637Z"
                  stroke="#333333"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <span>
                〜{{
                  props.spaceInfo?.generalSpaceInformationMaximumCapacity
                }}名
              </span>
            </div>
            <div class="area">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="11"
                height="11"
                viewBox="0 0 11 11"
                fill="none"
              >
                <g clip-path="url(#clip0_3426_358)">
                  <path
                    d="M6.7323 0.757202H9.5448C9.80457 0.757202 10.0135 0.966187 10.0135 1.22595V4.03845C10.0135 4.22791 9.90027 4.39978 9.72449 4.47205C9.54871 4.54431 9.34753 4.50525 9.21277 4.37048L8.45105 3.60876L6.75183 5.30798C6.56824 5.49158 6.27136 5.49158 6.08972 5.30798L5.46472 4.68298C5.28113 4.49939 5.28113 4.20251 5.46472 4.02087L7.16394 2.32166L6.40027 1.55798C6.2655 1.42322 6.22644 1.22205 6.29871 1.04626C6.37097 0.870483 6.54285 0.757202 6.7323 0.757202ZM3.2948 10.7572H0.4823C0.222534 10.7572 0.0135498 10.5482 0.0135498 10.2885V7.47595C0.0135498 7.2865 0.126831 7.11462 0.302612 7.04236C0.478394 6.97009 0.679565 7.00916 0.814331 7.14392L1.57605 7.90564L3.27527 6.20642C3.45886 6.02283 3.75574 6.02283 3.93738 6.20642L4.56238 6.83142C4.74597 7.01501 4.74597 7.31189 4.56238 7.49353L2.86316 9.19275L3.62488 9.95447C3.75964 10.0892 3.79871 10.2904 3.72644 10.4662C3.65417 10.642 3.4823 10.7552 3.29285 10.7552L3.2948 10.7572Z"
                    fill="#333333"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_3426_358">
                    <rect
                      width="10"
                      height="10"
                      fill="white"
                      transform="translate(0.0135498 0.757202)"
                    />
                  </clipPath>
                </defs>
              </svg>
              <span>〜{{ props.spaceInfo?.acreage }}㎡</span>
            </div>
            <PanoramaButton 
              :spaceInfo="props.spaceInfo" 
              outerClass="main-panorama-degree-tour" 
              innerClass="panorama-degree-tour"
            />
          </div>
        </div>
        <div class="price for-pc" v-if="props.isCampaign">
          <span style="text-decoration: line-through" class="campaign-price"
            >{{
              Number(
                Math.floor(1.1 * props.spaceInfo?.per_person_price)
              ).toLocaleString() + '円'
            }}〜</span
          >
          <svg
            width="21"
            height="21"
            viewBox="0 0 21 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11.3182 20.2429L9.26989 18.2145L15.4048 12.0795H0.5V9.11646H15.4048L9.26989 2.99146L11.3182 0.953102L20.9631 10.598L11.3182 20.2429Z"
              fill="#666666"
            />
          </svg>
          <span class="campaign-price" style="color: #FF3F3F;">{{
            Math.floor(
              Number(1.1 * props.spaceInfo?.per_person_price) -
                (Number(props.spaceInfo?.discount_rate) *
                  Number(1.1 * props.spaceInfo?.per_person_price)) /
                  100
            ).toLocaleString() + '円'
          }}〜</span>/1H
        </div>
        <div class="price for-pc" v-else>
          {{
            Math.floor(
              props.spaceInfo?.per_person_price * 1.1
            ).toLocaleString()+ '円'
          }}〜/1H
        </div>
      </div>
      <div
        class="label-group"
        style="color: #000000; text-decoration: none"
      >
        <div class="label-item">
          <div class="title" style="background-color: #eba25c">飲食</div>
          <div class="desc">
            {{
              props.spaceInfo?.included_amenities?.eating
                ? props.spaceInfo?.included_amenities?.eating
                : "-"
            }}
          </div>
        </div>
        <div class="label-item">
          <div class="title" style="background-color: #e7814a">飲酒</div>
          <div class="desc">
            {{
              props.spaceInfo?.included_amenities?.drinking
                ? props.spaceInfo?.included_amenities?.drinking
                : "-"
            }}
          </div>
        </div>
        <div class="label-item">
          <div class="title" style="background-color: #e25e58">
            ケータリング
          </div>
          <div class="desc">
            {{
              props.spaceInfo?.included_amenities?.catering == '不可'
                ? '対応不可'
                : (props.spaceInfo?.included_amenities?.catering ? props.spaceInfo?.included_amenities?.catering : "-")
            }}
          </div>
        </div>
        <div class="label-item">
          <div class="title" style="background-color: #6358e2">WiFi</div>
          <div class="desc">
            {{
              props.spaceInfo?.included_amenities?.wifi &&
              props.spaceInfo?.included_amenities?.wifi != "Wi-Fi無料！\n（準備中です)" &&
              props.spaceInfo?.included_amenities?.wifi !=
              "インターネット環境なし"
              ? "あり"
              : "なし"
            }}
          </div>
        </div>
        <div class="label-item">
          <div class="title" style="background-color: #2faba1">喫煙</div>
          <div class="desc">
            {{
              props.spaceInfo?.included_amenities?.smoking
                ? props.spaceInfo?.included_amenities?.smoking
                : "-"
            }}
          </div>
        </div>
      </div>
      <ScheduleGroup :spaceInfo="props.spaceInfo" v-if="isScheduleGroup !== 0" :no="no" :pageCurrent="pageCurrent" :isCampaign="props.isCampaign"/>
    </div>
  </div>
</template>

<script setup>
/* eslint-disable */
import { ref, watch, onMounted, defineAsyncComponent, computed } from "vue";
import { createOrDeleteFavoriteApi } from "@/client/api";
import { Carousel, Pagination, Slide } from "vue3-carousel";
import moment from "moment";
import { defineProps } from "vue";
import bestRateIcon from "@/client/assets/images/bestrateIcon.png";
import discountIcon from "@/client/assets/images/spaces/spaceItem/discount.svg";
import newIcon from "@/client/assets/images/spaces/spaceItem/new.svg";
import { useRouter, useRoute } from "vue-router";
import { ROUTER_PATH, ROUTE_NAME  } from "@/client/const";
import { ImageResizing } from "@/client/utils";

import HeartRed from "@/client/assets/icons/heart-red-icon.svg";
import HeartGray from "@/client/assets/icons/heart-gray-icon.svg";
import PanoramaButton from '@/client/components/Space/PanoramaButton.vue';

moment.locale("ja");
const currentSlide = ref(0);
const urlImages = ref([]);
const router = useRouter();
const route = useRoute();

const ScheduleGroup = defineAsyncComponent({
  loader: () => import('./ScheduleGroup.vue'),
  delay: 100000,
  timeout: 5000,
})

const props = defineProps({
  spaceInfo: {
    type: Object,
    default: () => {},
  },
  discountInfo: {
    type: Array,
    default: () => {
      return [];
    },
  },
  no: Number,
  pageCurrent: Number,
  isCampaign: {
    type: Boolean,
    default: () => false,
  },
  isSortByGroup: {
    type: Boolean,
    default: () => false,
  },
  isArea: {}
});

const isFavorite = ref(props?.spaceInfo?.like ? true : false);

const isScheduleGroup = ref(props?.spaceInfo?.web_reservation_status)

const isNew = (data) => {
  if (data.created_at == null) {
    return false;
  }
  const current = new Date().getTime();
  const createdAt = new Date(data.created_at).getTime();

  const diff = Math.floor((current - createdAt) / 86400000);
  return diff <= 30;
};

const isDiscount = (data) => {
  // const discountIdList = props.discountInfo.map((item) => {
  //   return item.rental_space_id;
  // });

  // if (!discountIdList.includes(data.id)) {
  //   return false;
  // }

  // const discount = props.discountInfo.find(
  //   (item) => item.rental_space_id === data.id
  // );

  // const current = new Date();
  // const startDate = new Date(moment(discount.start_date + " 00:00:00"));
  // if (!discount.end_date && startDate.getTime() <= current.getTime()) {
  //   return true;
  // }
  // const endDate = new Date(moment(discount.end_date + " 23:59:59"));
  if(typeof data.is_discount !== 'undefined') return data.is_discount;
  else {
    let current = new Date();
    if(data?.start_date && !data?.end_date) {
      const startDate = new Date(moment(data.start_date + " 00:00:00"));
      if(startDate.getTime() > current.getTime()) return false;
    } else if(!data?.start_date && data?.end_date) {
      const endDate = new Date(moment(data.end_date + " 23:59:59"));
      if(endDate.getTime() < current.getTime()) return false;
    } else if (data?.start_date && data?.end_date) {
      const startDate = new Date(moment(data.start_date + " 00:00:00"));
      const endDate = new Date(moment(data.end_date + " 23:59:59"));
        if (
        startDate.getTime() > current.getTime() ||
        endDate.getTime() < current.getTime()
      ) {
        return false;
      }
    }
    return true;
  }

};


const handelGotoDetailSpace = (id) => {
  return `${ROUTER_PATH.DETAIL}/${id}`;
};

const slideTo = (val) => {
  currentSlide.value = val;
};

const handleFavoriteSpaceId = async (spaceId) => {
  isFavorite.value = !isFavorite.value;
    try {
      await createOrDeleteFavoriteApi(spaceId, {});
    } catch (error) {
      isFavorite.value = !isFavorite.value;
      if (error?.status == 401) {
        const redirectParameters = {
          path: route.path,
          query: {
            ...route.query,
          },
        };
        sessionStorage.setItem(
          "redirectParameters",
          JSON.stringify(redirectParameters)
        );
        sessionStorage.setItem(
          "favoriteSpaceId",
          spaceId
        );
        return router.push(ROUTER_PATH.LOGIN);
      }
    }
};

const maxLength = ref(37);

const truncatedText = computed(() => {
  const text = props.spaceInfo?.generalBasicSpaceNameJa || '';
  /* if ([...text].length > maxLength.value) {
    return [...text].slice(0, maxLength.value).join('') + '...';
  } */
  return text;
});

const HandlePanoramaPage = () => {
    let url;
    let PanoramaEnvValue = props.spaceInfo?.entitiesImagePanoramaEavValue;
    if (PanoramaEnvValue?.length > 0) {
        const firstImageTitle = PanoramaEnvValue;

        var urlPattern = /(https?:\/\/|www\.)[^\s]+/g;

        if (urlPattern.test(firstImageTitle)) {
            url = `${ROUTER_PATH.PANORAMA}?id=${props.spaceInfo?.id}&show=true`;
        } else if(PanoramaEnvValue[0].width != 0 && PanoramaEnvValue[0].height != 0) {
            url = `${ROUTER_PATH.PANORAMA}?id=${props.spaceInfo?.id}`;
        }
    } else {
        url = `${ROUTER_PATH.PANORAMA}?id=${props.spaceInfo?.id}`;
    }

    window.open(url, '_blank')
};
</script>

<style scoped lang="scss">
@import "./SpaceItem.scss";
</style>
